import styled from "styled-components";

const StyledEmptyState = styled.div<{ $maxWidth?: number }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 600px;
  gap: 32px;

  & img {
    max-width: ${(props) => (props.$maxWidth ? props.$maxWidth : 300)}px;
    width: 100%;
  }
  & .label-div {
    text-align: center;
  }
`;

export { StyledEmptyState };
